/* eslint-disable import/first */
import { isAdminUser } from '../../../utils/adminUserTypes';
import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Button,
  Slide,
  Paper,
  IconButton,
  Card,
  Badge,
  CircularProgress,
  Stack,
  ClickAwayListener,
  Grow,
} from '@material-ui/core'
import { styled } from '@material-ui/styles'
import CloseIcon from '@material-ui/icons/Close'
import ChatIcon from '@material-ui/icons/Chat'
import ChatMain from './ChatMain'
import ChatSidebarSignWise from './ChatRightScreen/ChatSidebarSignWise'
import ChatScreenWindow from './ChatLeftScreen/ChatScreenWindow'
import { useDispatch } from 'react-redux'
import { getContacts, getConversations } from 'src/redux/slices/chat'
import IMG from '../../../Gif/apple-touch-icon.png'
import { MBadge } from 'src/components/@material-extend'
import axios from 'axios'
import { DOMAIN, REST_API_END_POINT, STATUS_OPTIONS } from 'src/constants/Defaultvalues'
import Draggable from 'react-draggable'
// import { io } from 'socket.io-client' // OLD — restore with REST_API_IO below when re-enabling socket
// import { DOMAIN, REST_API_END_POINT, REST_API_IO, STATUS_OPTIONS } from 'src/constants/Defaultvalues'
import createAppSocket from 'src/Helpers/createSocket'
// import owlNotification from '../../../assets/owl-notif.png'
// Styled Button for Floating Chat
const FloatingButton = styled(Button)(({ theme }) => ({
  // position: 'fixed',
  // bottom: 25,
  // right: 80, // Default value
  // zIndex: 1000,
  width: '50px',
  height: '50px',
  minWidth: '50px',
  borderRadius: '50%',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#1ccaff',
  transition: 'transform 0.3s ease',
  cursor: 'inherit',

  '&:hover': {
    backgroundColor: '#276699',
    transform: 'scale(1.1)',
  },
  '& *': {
    pointerEvents: 'none',
  },

  // Responsive styles
  // [theme.breakpoints.down('md')]: {
  //   right: 22, // Apply when screen width is below md (960px by default)
  //   bottom: 65, // Apply when screen height is below md (960px by default)
  // },
}))

// Styled Chat Popup Window
const PopupChat = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: 150,
  right: 70,
  zIndex: 1100,
  width: 'fit-content',
  // transformOrigin: 'top left',
  [theme.breakpoints.down('md')]: {
    right: 0, // Apply when screen width is below md (960px by default)
  },
}))

let chatListPromise = null
let chatStatusPromise = null

export default function FloatingChat() {
  const [open, setOpen] = useState(false)
  const [openCompose, setCompose] = useState(true)
  const dispatch = useDispatch()
  const user = localStorage.getItem('user')
  const userData = (() => {
    try {
      if (!user || user === 'null' || user === 'undefined') return null;
      return JSON.parse(user);
    } catch (e) {
      return null;
    }
  })();
  const isAdmin = userData && (userData.user_type !== undefined && userData.user_type !== null)
    ? isAdminUser(userData.user_type)
    : false
  const [teamMembers, setTeamMembers] = useState([])
  const [chatCount, setChatCount] = useState(0)
  console.log('chatCount+++++++++++', chatCount)
  const [selectedContact, setSelectedContact] = useState(null)
  const [renderChat, setRenderChat] = useState(false)
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState(null)
  const [refreshStatus, setRefreshStatus] = useState(false)
  const [showHistory, setShowHistory] = useState(true)
  const [chatOpenTime, setChatOpenTime] = useState(null)
  const [historyMessage, setHistoryMessage] = useState([])
  const [selectedChatLogId, setSelectedChatLogId] = useState(null)
  const [newChat, setNewChat] = useState(false)
  const [position, setPosition] = useState(null)
  const isDragging = useRef(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isDraggingNow, setIsDraggingNow] = useState(false);
  const socketRef = useRef(null);
  const owlNotification = `${process.env.PUBLIC_URL}/favicon/owl-notif.png`;
  const [onChatScreen,setOnChatScreen]=useState(false);
  const [mobileChat,setMobileChat]=useState(true);
  const canPlaySound = useRef(false); 
  const originalTitle = useRef(document.title);
  const blinkIntervalRef = useRef(null);
  const originalFavicon = useRef(null);
  const setFavicon = (iconURL) => {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = iconURL + '?v=' + new Date().getTime();
  };
  
  useEffect(() => {
    if (!userData?.user_id) return undefined;

    let notificationSound = new Audio('/sounds/text_message.mp3');
    let notificationSound2 = new Audio('/sounds/whatsapp_notification.mp3');
    if(userData.user_id===667){
      notificationSound = new Audio('/sounds/barking_dog.mp3');
      notificationSound2 = new Audio('/sounds/barking_dog.mp3');
    }
    const enableSound = () => {
      canPlaySound.current = true;
      notificationSound.load();
      notificationSound2.load();
    };
    
    ['click', 'keydown', 'touchstart'].forEach((eventName) => {
      window.addEventListener(eventName, enableSound, { once: true });
    });
    // OLD CODE (keep for future restore):
    // socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: [ "websocket", "polling"], secure: true });
    socketRef.current = createAppSocket();

    console.log('chatCount+++++++++++', )
    socketRef.current.on("message", (msg) => {
      if(msg?.domain===DOMAIN){

      let receivedConversationId = String(msg.conversationId);
      let senderConversationId = String(msg.senderId);
      let currentUserId = userData.user_id;
      const isOwnMessage = senderConversationId === String(currentUserId);
      const isGroupChat = Array.isArray(msg.participants) && msg.participants.length > 0;
      let userID =String(userData.user_id);
      if (msg.conversationId?.startsWith("user_")) {

        if (!userID.startsWith("user_")) userID = `user_${userID}`;
        if (!receivedConversationId.startsWith("user_")) receivedConversationId = `user_${receivedConversationId}`;
        if (!senderConversationId.startsWith("user_")) senderConversationId = `user_${senderConversationId}`;
        console.log('chatCount+++++++++++',receivedConversationId,userID,isOwnMessage,canPlaySound.current )
        if (receivedConversationId ===userID && !isOwnMessage ) {
          if (!open && !onChatScreen && canPlaySound.current) {
            notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
            if (!originalFavicon.current) {
              const link = document.querySelector("link[rel~='icon']");
              originalFavicon.current = link?.href;
            }
        
            let showBlue = true;
            console.log('showBlue+++++++++', showBlue)
            blinkIntervalRef.current = setInterval(() => {
              setFavicon(showBlue
                ? owlNotification
                : originalFavicon.current);
              showBlue = !showBlue;
            }, 1000);
          }
        // if (receivedConversationId === conversationId) {
        //   fetchMessages(conversationId);
        //   setRenderChat(!renderChat);
        //   handleRefresh();
        // } else {
        //   setTimeout(() => {
        //     // notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
        //     fetchMessages(conversationId);
        //     setRenderChat(!renderChat);
        //     handleRefresh();
        //   }, 1000);
        // }    
        if(open && onChatScreen && canPlaySound.current){
        notificationSound2.play().catch((e) => console.error("Failed to play sound:", e));
        // document.title = '● New Message - ' + originalTitle.current;
        fetchData()
        }
      }
      }else{
        if(isGroupChat){
          
          const participantIds = msg.participants.map(p => p.user_id);
          let  isRecipientInGroup = participantIds.includes(currentUserId);
              if (isRecipientInGroup && !isOwnMessage) {
                if (!open && !onChatScreen && canPlaySound.current) {
                notificationSound.play().catch((e) => console.error("Failed to play sound:", e));
                fetchData()
                }
            if (open && onChatScreen && canPlaySound.current ) {
              notificationSound2.play().catch((e) => console.error("Failed to play sound:", e));
              fetchData()
            }
          }
        }
      }  
    }});
    
    return () => {
      if (socketRef.current) socketRef.current.disconnect();
      if (blinkIntervalRef.current) {
        clearInterval(blinkIntervalRef.current);
        blinkIntervalRef.current = null;
      }
      if (originalFavicon.current) {
        setFavicon(originalFavicon.current);
      }
    };
  }, [userData]);

useEffect(() => {
  const handleFocus = () => {
    if (blinkIntervalRef.current) {
      clearInterval(blinkIntervalRef.current);
      blinkIntervalRef.current = null;
    }
    if (originalFavicon.current) {
      setFavicon(originalFavicon.current);
    }
    document.title = originalTitle.current;
  };

  window.addEventListener('focus', handleFocus);
  return () => {
    window.removeEventListener('focus', handleFocus);
  };
}, []);

  
console.log('owlNotification resolved path:', owlNotification);


  const isMobile = windowWidth < 768
  const isMd = windowWidth < 900

useEffect(() => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


  const clampPosition = (x, y) => ({
    x: Math.min(Math.max(0, x), window.innerWidth - 60),
    y: Math.min(Math.max(0, y), window.innerHeight - 60),
  })

  const fetchSavedPosition = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}get-chat-position`,
        {
          userId: userData.user_id,
        },
      )

      if (response.data.status === 1) {
        const { position_x, position_y } = response?.data
        if (
          position_x !== null &&
          position_y !== null &&
          position_x !== undefined &&
          position_y !== undefined
        ) {
          const clamped = clampPosition(position_x, position_y)
          setPosition(clamped)
        } else {
          const fallback = {
            x: window.innerWidth - 100,
            y: window.innerHeight - 150,
          }
          setPosition(fallback)
        }
      }
    } catch (err) {
      console.error('Failed to fetch saved position:', err)
      const fallback = {
        x: window.innerWidth - 100,
        y: window.innerHeight - 150,
      }
      setPosition(fallback)
    }
  }

  // useEffect(() => {
  //   // fetchSavedPosition()
  //   const clamped = clampPosition(314, 15)
  //   setPosition(clamped)
  // }, [isMd])

  const handleDrag = (e, data) => {
    isDragging.current = true
    setIsDraggingNow(true)
    setPosition({ x: data.x, y: data.y })
  }

  const handleDragStop = async (e, data) => {
    setTimeout(() => {
      isDragging.current = false
      setIsDraggingNow(false)
    }, 200)

    const clamped = clampPosition(data.x, data.y)
    setPosition(clamped)
    setPosition(clamped)

    try {
      await axios.post(`${REST_API_END_POINT}update-chat-position`, {
        userId: userData.user_id,
        chat_position_x: data.x,
        chat_position_y: data.y,
      })
      console.log(' Chat position saved:', clamped)
    } catch (err) {
      console.error(' Failed to save position:', err)
    }
  }

  // const fetchStatus = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${REST_API_END_POINT}chat/get-chat-status-by-userid`,
  //       { userId: userData.user_id },
  //     )
  //     if (response.data.status === 1) {
  //       const fetchedStatus = response.data.result.chat_status
  //       const filteredStatus = STATUS_OPTIONS?.find(
  //         (item) => item.id == fetchedStatus,
  //       )
  //       console.log('newStatus---filteredStatus-1--', filteredStatus)
  //       setStatus(filteredStatus)
  //       console.log('Status set successfully')
  //     } else {
  //       console.log('Status not found')
  //     }
  //   } catch (error) {
  //     console.log('Error finding status : ', error)
  //   }
  // }

  const fetchStatus = async () => {
    if (!userData?.user_id) return
  
    try {
      if (!chatStatusPromise) {
        chatStatusPromise = axios.post(
          `${REST_API_END_POINT}chat/get-chat-status-by-userid`,
          { userId: userData.user_id },
        )
      }
  
      const response = await chatStatusPromise
  
      if (response.data.status === 1) {
        const fetchedStatus = response.data.result.chat_status
        const filteredStatus = STATUS_OPTIONS?.find(
          (item) => item.id == fetchedStatus,
        )
        setStatus(filteredStatus)
      } else {
        console.log('Status not found')
      }
    } catch (error) {
      console.log('Error finding status : ', error)
    } finally {
      chatStatusPromise = null
    }
  }

  useEffect(() => {
    fetchStatus()
  }, [refreshStatus, open])
  // const fetchData = async (updateSelctedContact = false) => {
  //   if (isAdmin && userData) {
  //     try {
  //       const response = await axios.post(
  //         `${REST_API_END_POINT}chat/get-chat-list`,
  //         {
  //           usersId: userData.user_id,
  //           usersType: userData.user_type,
  //           // page:page+1,rowsPerPage,search:filterName,
  //         },
  //       )
  //       if (response.data.data) {
  //         const newData = response.data.data
  //         const TotalUnread = response.data.totalUnreadCount
  //         setTeamMembers(newData)
  //         setChatCount(TotalUnread)
  //         if (updateSelctedContact) {
  //           const filteredData = newData.find(
  //             (member) =>
  //               member?.new_conversation_id ===
  //               selectedContact?.new_conversation_id,
  //           )
  //           console.log('selectedContact---', selectedContact)
  //           console.log('filteredData---', filteredData)
  //           setSelectedContact(filteredData)
  //         }
  //       } else {
  //         setTeamMembers([])
  //         setChatCount(0)
  //       }
  //     } catch (error) {
  //       console.log('Error fetching data: ', error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }
  // }

  const fetchData = async (updateSelctedContact = false) => {
    // if (!isAdmin || !userData?.user_id) return
  
    try {
      if (!chatListPromise) {
        chatListPromise = axios.post(
          `${REST_API_END_POINT}chat/get-chat-list`,
          {
            usersId: userData.user_id,
            usersType: userData.user_type,
          },
        )
      }
  
      const response = await chatListPromise
  
      if (response.data.data) {
        const newData = response.data.data
        const TotalUnread = response.data.totalUnreadCount
        setTeamMembers(newData)
        setChatCount(TotalUnread)
  
        if (updateSelctedContact) {
          const filteredData = newData.find(
            (member) =>
              member?.new_conversation_id ===
              selectedContact?.new_conversation_id,
          )
          setSelectedContact(filteredData || null)
        }
      } else {
        setTeamMembers([])
        setChatCount(0)
      }
    } catch (error) {
      console.log('Error fetching data: ', error)
    } finally {
      chatListPromise = null
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [open])

  useEffect(() => {
    if (!renderChat) return
    fetchData(true)
  }, [renderChat])

  const handleRefresh = () => {
    fetchData(true)
  }

  const refreshChat = () => {
    setRenderChat((prev) => !prev)
  }

  useEffect(() => {
    dispatch(getConversations())
    dispatch(getContacts())
  }, [dispatch])

  const togglePopup = () => {
    setOpen(!open)
    setOnChatScreen(!onChatScreen)
    setCompose(true)
    setShowHistory(false)
    setSelectedContact(null)
    // console.log('showHistoryshowHistory',!showHistory,selectedContact)
  }
  const openChat = () => {
    setCompose(false)
  }

  if (!userData) {
    return null;
  }

  return (
    <>
      {/* <FloatingButton onClick={togglePopup}>
        <Badge badgeContent={3} color="error" overlap="circular">
          <Box
            component="img"
            src={IMG}
            alt="LOGO"
            sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
          />
        </Badge>
      </FloatingButton> */}

      {/* {position && !isMobile && (
        <Draggable
          bounds="body"
          position={position}
          onDrag={handleDrag}
          onStop={handleDragStop}
        >
          <div
            className="drag-wrapper"
            style={{ position: 'fixed', zIndex: 9999,cursor: isDraggingNow ? 'grabbing' : 'grab', }}
          >
            <FloatingButton
              onClick={() => {
                if (!isDragging.current) togglePopup()
              }}
            >
              <Badge badgeContent={chatCount} color="error" overlap="circular">
                <Box
                  component="img"
                  src={IMG}
                  alt="LOGO"
                  sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
                />
              </Badge>
            </FloatingButton>
          </div>
        </Draggable>
      )} */}
      
        <FloatingButton
          onClick={() => {
            if (!isDragging.current) togglePopup()
          }}
        >
          <Badge badgeContent={chatCount} color="error" overlap="circular">
            <Box
              component="img"
              src={IMG}
              alt="LOGO"
              sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
            />
          </Badge>
        </FloatingButton>
      

      {/* {isMobile && (
        <div style={{ position: 'fixed', bottom: 80, right: 80, zIndex: 9999,cursor: isDragging.current ? 'grabbing' : 'grab', }}>
          <FloatingButton onClick={togglePopup}>
            <Badge badgeContent={chatCount} color="error" overlap="circular">
              <Box
                component="img"
                src={IMG}
                alt="LOGO"
                sx={{ width: 45, height: 45, objectFit: 'cover', mt: 0.5 }}
              />
            </Badge>
          </FloatingButton>
        </div>
      )} */}

      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      {/* <Grow in={open} mountOnEnter unmountOnExit> */}
        <PopupChat>
          {/* {loading ? 
              <Stack alignItems='center' justifyContent='center'>
                <CircularProgress color="primary" variant="indeterminate" />
              </Stack>: */}
          {/* {isMobile ?
          (<Card sx={{ height: '72vh', display: 'flex' }}>
            {mobileChat ?<ChatSidebarSignWise
              openCompose={openCompose}
              setCompose={setCompose}
              setOpen={setOpen}
              teamMembers={teamMembers}
              setSelectedContact={setSelectedContact}
              selectedContact={selectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              status={status}
              setStatus={setStatus}
              refresh={refreshStatus}
              setRefresh={setRefreshStatus}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
              handleRefresh={handleRefresh}
              setMobileChat={setMobileChat}
            />:
            <ChatScreenWindow
            setOnChatScreen={setOnChatScreen}
              openCompose={openCompose}
              setCompose={setCompose}
              teamMembers={teamMembers}
              contact={selectedContact}
              setSelectedContact={setSelectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              handleRefresh={handleRefresh}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
            />}
          </Card>)
          :( */}
          <Card sx={{ height: '72vh', display: 'flex' }}>
            <ChatSidebarSignWise
              openCompose={openCompose}
              setCompose={setCompose}
              setOpen={setOpen}
              teamMembers={teamMembers}
              setSelectedContact={setSelectedContact}
              selectedContact={selectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              status={status}
              setStatus={setStatus}
              refresh={refreshStatus}
              setRefresh={setRefreshStatus}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
              handleRefresh={handleRefresh}
            />
            <ChatScreenWindow
            setOnChatScreen={setOnChatScreen}
              openCompose={openCompose}
              setCompose={setCompose}
              teamMembers={teamMembers}
              contact={selectedContact}
              setSelectedContact={setSelectedContact}
              refreshChat={refreshChat}
              setRenderChat={setRenderChat}
              renderChat={renderChat}
              handleRefresh={handleRefresh}
              setShowHistory={setShowHistory}
              showHistory={showHistory}
              chatOpenTime={chatOpenTime}
              setChatOpenTime={setChatOpenTime}
              setHistoryMessage={setHistoryMessage}
              historyMessage={historyMessage}
              selectedChatLogId={selectedChatLogId}
              setSelectedChatLogId={setSelectedChatLogId}
              setNewChat={setNewChat}
              newChat={newChat}
            />
          </Card>
          {/* )} */}
          {/* } */}
        </PopupChat>
      {/* </Grow> */}
      </Slide>
    </>
  )
}
